export default "__VITE_ASSET__60A6eIM___"